import {
  AlignLeft,
  Code,
  FileText,
  RemoveFormatting,
  Tags,
  Type,
} from "lucide-react";
import type { ContentTypeConfig } from "@/types/autopilot";

const fieldEquivalents = [
  {
    fields: ["base_name", "name", "title", "product_name"],
    icon: RemoveFormatting,
    color: "text-blue-500",
  },
  {
    fields: ["seo_page_title", "meta_title", "page_title", "seo_title"],
    icon: Type,
    color: "text-blue-500",
  },
  {
    fields: ["seo_meta_desc", "seo_description", "meta_description"],
    icon: FileText,
    color: "text-green-500",
  },
  {
    fields: [
      "long_description",
      "description",
      "description_html",
      "description_details",
    ],
    icon: Code,
    color: "text-purple-500",
  },
  {
    fields: ["short_description"],
    icon: AlignLeft,
    color: "text-yellow-500",
  },
  {
    fields: ["tags"],
    icon: Tags,
    color: "text-orange-500",
  },
];
export const CONTENT_TYPES: ContentTypeConfig[] = fieldEquivalents.flatMap(
  (eq) =>
    eq.fields.map((field) => ({
      value: field,
      label: field,
      icon: eq.icon,
      color: eq.color,
    })),
);
